import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { seventhAnalysesActions } from 'features/seventhAnalyses';

const useSeventhAnalyses = () => {
  const dispatch = useDispatch();
  const getSeventhAnalyses = useCallback(({ offset }) => dispatch(seventhAnalysesActions.getSeventhAnalyses({ offset })), [dispatch]);
  const getSeventhAnalysis = useCallback(({ id, cable }) => dispatch(seventhAnalysesActions.getSeventhAnalysis({ id, cable })), [dispatch]);
  const clearLocalSeventhAnalyses = useCallback(() => dispatch(seventhAnalysesActions.clearLocalSeventhAnalyses()), [dispatch]);
  const clearLocalActiveSeventhAnalysis = useCallback(() => dispatch(seventhAnalysesActions.clearLocalActiveSeventhAnalysis()), [dispatch]);

  return {
    getSeventhAnalyses,
    getSeventhAnalysis,
    clearLocalSeventhAnalyses,
    clearLocalActiveSeventhAnalysis
  };
};

export default useSeventhAnalyses;